import type { FaireProductEntity } from "../../entity_types/product";

export const p_ktkfc784rv: FaireProductEntity = {
  token: "p_ktkfc784rv",
  type: "product",
  name: '"Sophie Hood"',
  brandToken: "b_2f4gf52uef",
  brandName: "Calie Paris",
  imageUrl:
    "https://cdn.faire.com/fastly/dcd739bcccba4223a131955fa62d1803178b5fa412783fa78a313633944e577b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d03523cc0aad7b8972a408f129196c29060b0473bed7fad059af440c13a6d098.jpeg",
    "https://cdn.faire.com/fastly/1aba31b336147618a96d3664bc32f145892180c0c9d11ee44abff27107304b63.jpeg",
    "https://cdn.faire.com/fastly/259dea54948b698a2aa5073e02a16bcda87583fb3e6b316d6ba19790ed575243.jpeg",
    "https://cdn.faire.com/fastly/e898ac1a178e3ff6087310a9af77783755877138b0406b5fa950eedba6cf01da.jpeg",
    "https://cdn.faire.com/fastly/66ae3317384705fa1f924e3537ea0e9b00b43c697ac0f7d9f9e913f480ec861f.jpeg",
    "https://cdn.faire.com/fastly/ca02296f413b40d393cfa93089cf50edc1f041f51554d3ee00571491bb42f30a.jpeg",
    "https://cdn.faire.com/fastly/a1587f6ab7cc76bac2a2fd5d6ff2720051d2474cbdafd95f989907fbefdf75ed.jpeg",
    "https://cdn.faire.com/fastly/94654088dda64f48c8a4b2d704de3d0067deaf02115be2093c64543f2f071126.jpeg",
    "https://cdn.faire.com/fastly/7541f1814345c56f3618cd568f88a4dd4c3900d112bb9236799619632f3ebed0.jpeg",
    "https://cdn.faire.com/fastly/e354080a156f25f8cbf12ee84d60fc02756d8403172886929b256487aa959515.jpeg",
    "https://cdn.faire.com/fastly/282b884b769f386c4c068d561267c5c56d4681ccfedbb252e1d5f27097bd1ceb.jpeg",
    "https://cdn.faire.com/fastly/371fc9309d784e116336ed9d060a172d991926f8b0368d96e85b22321e86ed49.jpeg",
    "https://cdn.faire.com/fastly/b17e31e9cd7749610066425d4eebfc314aa3061b58d4a00b8ba06ff1d2c28711.jpeg",
    "https://cdn.faire.com/fastly/56f346cd4a932012852fa355bb45eaadcc95783a4544f5b901844ae3b9352c22.jpeg",
    "https://cdn.faire.com/fastly/48aebca5ed8c8376878990321b6a86e17f4d95253cd329d5dd673572c17bfc4c.jpeg",
    "https://cdn.faire.com/fastly/fc2c1d8541162c7e939efb697cf5ff96e8409cccab4b86031e020d725e5ee39e.jpeg",
    "https://cdn.faire.com/fastly/b399785f58d0fba98cb2672b3273cfdfe820d69dcf54226d5aef236405e39f4f.jpeg",
    "https://cdn.faire.com/fastly/3ff4fc562fc7872b064838a2530f0644770b040ddfa5b15500d2690c27ce4102.jpeg",
    "https://cdn.faire.com/fastly/fd400039ceed39ca5bedb53a03ba42b6834b96520be0d733b94315a8c1e21f02.jpeg",
    "https://cdn.faire.com/fastly/24ce6e10ca13ea14ecf1d17533a5884b8f9737305aa63a77922398acc8b525de.jpeg",
    "https://cdn.faire.com/fastly/34be0bbfcd9593a42cf3b4948c6c0e9a26fdcc0dc15dcab48f374c620d3f28f0.jpeg",
    "https://cdn.faire.com/fastly/6347f27a245079a877780cc161205bdd0a331784e1bff6daea885b5a239d5647.jpeg",
    "https://cdn.faire.com/fastly/e423f1980df144fa8553a53faa2a9e7e4a3d5993e05b13b2448f6a438358f233.jpeg",
    "https://cdn.faire.com/fastly/ce7f49c652bb9c3ef85b06e1712e9b829e0591ce51c4b02f6a77d71fdbd184e0.jpeg",
    "https://cdn.faire.com/fastly/eb2af71951660d1d85015725bfe65b22e3fe022175d01dff83cded0790e3ce71.jpeg",
    "https://cdn.faire.com/fastly/de8167f0996ad3318c9a4063a6420e25f5386b5120616bc3d332fa7008fcd37c.jpeg",
    "https://cdn.faire.com/fastly/b5996fc97ddd8f6ed23a4fd61c3023ff1ad756171eb03732ce65de3e44b1b33f.jpeg",
    "https://cdn.faire.com/fastly/e484c408abb558c1c66f0af7014c04633005d95fc2f7dd5353d78f7429d1c0ac.jpeg",
    "https://cdn.faire.com/fastly/b1cbfa3bb9e852811e7465e58300d515d3f67f63b8c28687e6805ca3944b09b1.jpeg",
    "https://cdn.faire.com/fastly/4b9cf3b392f0f9ba709a0dbd6b377b76e5ff5dce705c862178bf27d7d102cb94.jpeg",
    "https://cdn.faire.com/fastly/2841c39ed735a0e033c5b8f1a9cb9e3b7bf6c39720f6e452279598c9a34cf1a5.jpeg",
    "https://cdn.faire.com/fastly/db67cf22b810e980abb66a5e8506731bd35a4fd3a6f5ab3d2a9dc1ce00b30160.jpeg",
    "https://cdn.faire.com/fastly/735e127507135a5daef7f082c6633ade1692c5de2fe897c7ccda002db89000d1.jpeg",
    "https://cdn.faire.com/fastly/e0c28080f1a500b61a1cc50c6d726399517577a6645ecb753cbe2b5d0f4a109d.jpeg",
    "https://cdn.faire.com/fastly/8a52d6845fdf3d47632f9ab3f35f05711dc422962db61e42d0d1d184ecb4ec2a.jpeg",
  ],
  priceDollars: 21.05,
  description:
    'You\'ve must seen it a lot lately on the social medias, this is the hood version of the "Sophie Scarf"\n10% Cashmere, 40% Merinos wool, 30% Viscose, 20% Recycled Polyamide',
  tags: [],
  msrpDollars: 45.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:38.991Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
